// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xg_a bhc_vn bhc_vf bhc_xb bhc_re bhc_tp bhc_qv"};